import { useState, useEffect } from 'react';
import type { FC, ReactNode } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';

import cn from '@core/utils/classNames';

import styles from './JoTooltip.module.css';

type Props = {
  trigger?: string | ReactNode;
  text: string | ReactNode;
  buttonText?: string | ReactNode;
  fitParent?: boolean;
};

const JoTooltip: FC<Props> = ({
  trigger = <BsQuestionCircle size={12} />,
  text,
  buttonText = <IoClose size={16} />,
  fitParent = false,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    if (!isTooltipOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      const openTooltip = document.querySelector(`.${styles.tooltip}`);
      if (openTooltip && !openTooltip.contains(event.target as Node)) {
        setIsTooltipOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    // eslint-disable-next-line consistent-return
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isTooltipOpen]);

  const handleCloseTooltip = () => {
    setIsTooltipOpen(false);
  };

  return (
    <>
      <button
        className={styles.tooltipTrigger}
        type="button"
        onClick={(e) => {
          setIsTooltipOpen(!isTooltipOpen);
          e.stopPropagation();
        }}
      >
        {trigger}
      </button>
      {isTooltipOpen && (
        <div className={styles.tooltip}>
          <button
            type="button"
            className={styles.tooltipCloseButton}
            onClick={(e) => {
              handleCloseTooltip();
              e.stopPropagation();
            }}
          >
            {buttonText}
          </button>
          <div className={styles.tooltipContent}>{text}</div>
        </div>
      )}
    </>
  );
};

export default JoTooltip;
